export default __webpack_public_path__ + "media/images/features/jtb/underline-fd37b3f768d02bf441d50dcfdc9c3ae2.png";